module.exports = __webpack_public_path__ + "static/img/personal.07897855.svg";